export default function useDataTransform(props, data) {
  return props.data
}
